
const depositsDataFilter={
    all:'all',
    accepted:'accepted',
    rejected:'rejected',
    pending:'pending'
}
export default depositsDataFilter;
